import {
    CARD_PROCESSOR_DATA_REQUEST,
    CARD_PROCESSOR_DATA_SUCCESS,
    CARD_PROCESSOR_DATA_FAILURE,
} from "../actions/actionTypes";
import apiClient from "../../utils/apiClient";

export const cardProcessorDataThunk = (FIN, signature) => {
    
  return async (dispatch) => {

    dispatch({ type: CARD_PROCESSOR_DATA_REQUEST });
    try {
      const response = await apiClient.post(
        "/printableCredentialRoute",
        { uin: FIN, signature }
      );

      const data = response.data;

      dispatch({ type: CARD_PROCESSOR_DATA_SUCCESS, payload: data.pdf });
      
    } catch (error) {
      dispatch({
        type: CARD_PROCESSOR_DATA_FAILURE,
        payload:
          error.message || "fetching data has failed. Please try again later.",
      });
    }
  };
};
